import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { useWorkspaceStore } from '../stores/workspace';

declare module 'vue-router' {
  interface RouteMeta {
    auth?: boolean;
    guest?: boolean;
    requiresWorkspaceAdmin?: boolean;
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/LoginPage.vue'),
      meta: { guest: true },
    },
    {
      path: '/',
      component: () => import('../components/layout/AppLayout.vue'),
      meta: { auth: true },
      children: [
        { path: '', redirect: '/inbox' },
        { path: 'inbox/:conversationId?', name: 'inbox', component: () => import('../pages/InboxPage.vue') },
        { path: 'contacts', name: 'contacts', component: () => import('../pages/ContactsPage.vue') },
        { path: 'broadcasts', name: 'broadcasts', component: () => import('../pages/ComingSoonPage.vue') },
        { path: 'ai', name: 'ai', component: () => import('../pages/AiAgentsPage.vue') },
        { path: 'ai-agents', name: 'ai-agents', component: () => import('../pages/AiAgentsPage.vue') },
        { path: 'workflows', name: 'workflows', component: () => import('../pages/WorkflowsPage.vue') },
        { path: 'workflows/new', name: 'workflow-new', component: () => import('../pages/WorkflowBuilder.vue') },
        { path: 'workflows/:id', name: 'workflow-edit', component: () => import('../pages/WorkflowBuilder.vue') },
        { path: 'workspaces', name: 'workspaces', component: () => import('../pages/WorkspacesPage.vue'), meta: { requiresWorkspaceAdmin: true } },
        { path: 'analytics', name: 'analytics', component: () => import('../pages/ComingSoonPage.vue') },
        { path: 'settings', name: 'settings', component: () => import('../pages/SettingsPage.vue') },
      ],
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const auth = useAuthStore();

  if (to.meta.auth && !auth.isAuthenticated) {
    next('/login');
    return;
  }
  if (to.meta.guest && auth.isAuthenticated) {
    next('/inbox');
    return;
  }
  if (to.meta.requiresWorkspaceAdmin) {
    const ws = useWorkspaceStore();
    if (!ws.canManageWorkspace) {
      next('/inbox');
      return;
    }
  }
  next();
});

export { router };
export default router;
